import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';

import { RxRadioGroupComponent } from './rx-radio-group.component';
import { RxRadioDirective } from './rx-radio';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatRadioModule,
    MatListModule,
    ReactiveFormsModule,
    RxRadioGroupComponent,
    RxRadioDirective,
  ],
  exports: [RxRadioGroupComponent, RxRadioDirective],
})
export class RxRadioGroupModule {}
